var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFunk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56.378,
    height: 56.378,
    viewBox: "0 0 56.378 56.378",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_236",
    "data-name": "Rectangle 236",
    width: 56.378,
    height: 56.378,
    fill: "#c4e7f8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-funk",
    transform: "translate(13 6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_389",
    "data-name": "Group 389",
    transform: "translate(-13 -6)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    "data-name": "Path 424",
    d: "M52.912,24.8H49.357a21.389,21.389,0,0,0-.678-3.019l1.574-.658a1.73,1.73,0,1,0-1.343-3.189l-1.554.651a21.116,21.116,0,0,0-1.649-2.741l2.707-2.714a3.459,3.459,0,0,0-4.892-4.892L40.829,10.93a22.061,22.061,0,0,0-2.646-1.642l.685-1.683a1.708,1.708,0,0,0-.095-1.479,1.726,1.726,0,0,0-3.209-.02L34.838,7.89a21.061,21.061,0,0,0-3.087-.719v-3.7a3.46,3.46,0,1,0-6.92,0V7.2a20.852,20.852,0,0,0-3.053.733l-.651-1.56a1.73,1.73,0,0,0-3.2.034,1.715,1.715,0,0,0-.041,1.4l.631,1.5a21.551,21.551,0,0,0-2.449,1.506L13.392,8.141A3.459,3.459,0,0,0,8.5,13.033l2.653,2.653A21.721,21.721,0,0,0,9.4,18.562l-1.574-.645a1.732,1.732,0,0,0-1.3,3.209l1.547.631A20.993,20.993,0,0,0,7.4,24.7H3.46a3.46,3.46,0,1,0,0,6.92H7.388a21.506,21.506,0,0,0,.719,3.053l-2.015.855a1.728,1.728,0,0,0,.672,3.324,1.643,1.643,0,0,0,.665-.136l2.015-.848a21.37,21.37,0,0,0,1.628,2.666l-2.605,2.6a3.464,3.464,0,0,0,4.9,4.9l2.6-2.6A21.363,21.363,0,0,0,18.6,47.057l-.794,1.954a1.72,1.72,0,0,0,.95,2.252,1.689,1.689,0,0,0,.651.129,1.731,1.731,0,0,0,1.6-1.079l.78-1.92a20.2,20.2,0,0,0,2.924.712v3.813a3.463,3.463,0,0,0,6.927,0V49.167a21.273,21.273,0,0,0,3.229-.746l.794,1.879a1.73,1.73,0,0,0,1.594,1.058,1.7,1.7,0,0,0,.672-.136,1.727,1.727,0,0,0,.923-2.266l-.787-1.866a21.754,21.754,0,0,0,2.687-1.649l2.632,2.639a3.461,3.461,0,1,0,4.9-4.892L45.645,40.55a21.364,21.364,0,0,0,1.628-2.639l1.811.733a1.689,1.689,0,0,0,.651.129,1.729,1.729,0,0,0,.651-3.331l-1.778-.726a21.756,21.756,0,0,0,.719-2.985h3.582a3.463,3.463,0,0,0,0-6.927M18.7,34.709a5.092,5.092,0,1,1,5.088-5.088A5.086,5.086,0,0,1,18.7,34.709M24.98,20.6a6.411,6.411,0,1,1,6.411,6.411A6.41,6.41,0,0,1,24.98,20.6m8.569,20.36a4.292,4.292,0,1,1,4.369-4.295,4.329,4.329,0,0,1-4.369,4.295",
    transform: "translate(0 0.002)",
    fill: "#c4e7f8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFunk);
export default __webpack_public_path__ + "static/media/icon-funk.da449e397e1e00d52b1c307116480ecc.svg";
export { ForwardRef as ReactComponent };